<script>
import ProgressBar from "./ProgressBar.vue";
import VehicleInfo from "./Steps/VehicleInfo.vue";
import {useAppointmentStore, useOfferStore} from "../../stores/appointment";
import GarageOverview from "./Steps/GarageOverview.vue";
import Services from "./Steps/Services.vue";
import ContactInfo from "./Steps/ContactInfo.vue";
import AppointmentSidebar from "./AppointmentSidebar.vue";

export default {
    name: "Wrapper",

    props: {
        title: {
            type: String,
            required: false,
        },
        uspsText: String,
        vehicleText: String,
        garagesText: String,
        servicesText: String,
        contactText: String,
        services: Array,
        redirectUrl: String,
        blockedDates: Array,
        initialGarage: {
            type: Object,
            required: false,
            default: () => {},
        },
        requestOffer: {
            type: Boolean,
            default: false,
        }
    },

    components: {AppointmentSidebar, ContactInfo, Services, GarageOverview, VehicleInfo, ProgressBar},

    computed: {
       appointmentStore() {
           return this.requestOffer ? useOfferStore() : useAppointmentStore()
       }
    },

    created() {
        this.appointmentStore.services = this.services;
        this.appointmentStore.redirectUrl = this.redirectUrl;
        this.appointmentStore.blockedDates = this.blockedDates;
        this.appointmentStore.initialGarage = this.initialGarage;

        this.pushToDataLayer(this.appointmentStore.activeStep);
    },

    methods: {
        pushToDataLayer(step) {
            const event = this.requestOffer ? "offerte_aanvraag" : "afspraak_aanvraag";
            const stepLabels = {
                1: "1. Mijn voertuig",
                2: "2. Vestiging & datum",
                3: "3. Services kiezen",
                4: "4. Contact gegevens"
            };

            const stapLabel = stepLabels[step];

            if (stapLabel) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: event,
                    stap: stapLabel
                });
            }
        }
    },

    watch: {
        'appointmentStore.activeStep'(newStep) {
            this.pushToDataLayer(newStep);
        }
    }
}
</script>

<template>
    <div class="vue-appointment-wrapper">
        <ProgressBar :request-offer="requestOffer" :title="title" />

        <div class="vue-appointment-content">
            <template  v-if="appointmentStore.activeStep === 1" >
                <VehicleInfo :uspsText="uspsText" :vehicleText="vehicleText" :request-offer="requestOffer" />
            </template>

            <template v-if="appointmentStore.activeStep > 1">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-7">
                            <GarageOverview v-if="appointmentStore.activeStep === 2" :request-offer="requestOffer" :garagesText="garagesText" />
                            <Services v-if="appointmentStore.activeStep === 3" :request-offer="requestOffer" :servicesText="servicesText" />
                            <ContactInfo v-if="appointmentStore.activeStep === 4" :request-offer="requestOffer" :contactText="contactText" />
                        </div>

                        <div class="col-12 col-md-5 col-lg-4 offset-lg-1 mt-4 mt-md-0">
                            <AppointmentSidebar :request-offer="requestOffer" />
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>